var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.loading && _vm.slides.length === 0)?_c('LoadingState'):_c('OnboardingSteps',{attrs:{"steps":_vm.slides}}),_c('Chat',{attrs:{"type":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }